import type { ReactNode } from 'react';
import styled from 'styled-components';
import { Spin } from 'antd';

const Loading = (): ReactNode => {
  return (
    <Container>
      <Spin size="large" />
    </Container>
  );
};

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  background: #e5e5e8;
  opacity: 0.6;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export { Loading };
